import { useContext } from "react";
import { Switch } from "@headlessui/react";
import { Context } from "../../../context/Context";

function Toggle() {
  const { state, setState } = useContext(Context);

  return (
    <Switch
      checked={state.editor.lineNumber}
      onChange={(value) => {
        let tempState = { ...state };
        tempState.editor.lineNumber = value;
        setState(tempState);
      }}
      className={`outline-none ${
        state.editor.lineNumber ? "bg-indigo-600" : "bg-gray-200 "
      } relative inline-flex items-center h-6 rounded-full w-11`}
    >
      <span className="sr-only">Enable notifications</span>
      <span
        className={`transform transition ease-in-out duration-200 ${
          state.editor.lineNumber ? "translate-x-6" : "translate-x-1"
        } inline-block w-4 h-4 transform bg-white rounded-full`}
      />
    </Switch>
  );
}
export default Toggle;
